
export enum WedgeRewardType {
    DiceRoll = "DICE_ROLL",
    Shield = "SHIELD",
    Coin = "COIN",
}